import { createContext, useContext, ReactNode } from 'react';

type DatagridCellContextValue = {
  noRowHeightAuto?: boolean;
};

const DatagridCellContext = createContext<DatagridCellContextValue>({});

export const DatagridCellProvider = ({
  children,
  noRowHeightAuto,
}: {
  children: ReactNode;
  noRowHeightAuto?: boolean;
}) => (
  <DatagridCellContext.Provider value={{ noRowHeightAuto }}>
    {children}
  </DatagridCellContext.Provider>
);

export const useDatagridCellContext = () => useContext(DatagridCellContext);
